import React from 'react';
import { connect } from 'react-redux';
import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { OrderType } from '@epi-constants/orderType';
import { InvoicingContactPersonField } from '@epi-forms/controls/InvoicingContactPersonField';
import { InvoicingCostCenter } from '@epi-forms/controls/InvoicingCostCenter';
import { WithoutReferenceNumberCheckbox } from '@epi-forms/controls/WithoutReferenceNumberCheckbox';
import { DownloadInvoiceProps } from '@epi-models/forms/DownloadInvoice';

import './DownloadInvoice.scss';

function DownloadInvoice({ orderType }: DownloadInvoiceProps) {
  const { t } = useTranslation();
  const { gray10 } = useTheme();

  return (
    <Box border="1px solid" borderColor={gray10} p={2}>
      {orderType === OrderType.voucher && (
        <Box>{t('forms.payment_method.order_shipped_after_payment')}</Box>
      )}
      {t('forms.payment_method.invoice_additional_fields')}
      <Box display="flex" gap={5}>
        <InvoicingCostCenter />
        <InvoicingContactPersonField />
      </Box>
      <Box marginTop="20px">
        <WithoutReferenceNumberCheckbox />
      </Box>
    </Box>
  );
}

const DownloadInvoiceWithI18n = connect()(DownloadInvoice);

export { DownloadInvoiceWithI18n as DownloadInvoice };
